<template>
    <section id="header">
        <nav class="navbar">
            <router-link to="/">
                <i class="fa fa-reorder" />
            </router-link>
            <div class="brand flex justify-content-center">
                <img v-if="brand === 'vw'" alt="logo" src="@/assets/svg/logo-vw.svg" />
                <img v-if="brand === 'audi'" alt="logo" src="@/assets/svg/logo-audi.svg" />
                <img v-if="brand === 'seat'" alt="logo" src="@/assets/svg/logo-seat.svg" />
                <img v-if="brand === 'porsche'" alt="logo" src="@/assets/svg/logo-porsche.svg" />
            </div>
            <div class="right"></div>
            <div class="toggle"></div>
        </nav>
    </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useLoginStore } from "../stores/login/loginStore";

export default defineComponent({
    name: "TemplateView",
    setup() {
        const login = useLoginStore();
        const brand = import.meta.env.VITE_BRAND;

        /**
         * Control del menu para seleccionar una marca.
         * @param {string} urlImage - Proviene del arreglo brands declarado usando la directiva command.
         * @param {string} brand - Proviene del arreglo brands declarado usando la directiva command.
         * @return {null} Sin respuesta
         */
        function selectBrand(urlImage: string, brand: string): void {
            localStorage.setItem("brand", brand);
            localStorage.setItem("srcImage", urlImage);
            /** Aquí llamamos al store para cambiar de marca */
            location.reload();
        }

        return {
            brand,
            login,
            selectBrand,
        };
    },
});
</script>
